<template>
  <div>
    <slot :show="show" :dismiss="dismiss" />
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'AlertDismissible',

  props: {
    name: {
      type: String,
      required: true,
    },

    userId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      show: false,
    }
  },

  apollo: {
    hasDismissedAlert: {
      query: gql`
        query hasDismissedAlert($name: String!) {
          me {
            globalId
            hasDismissedAlert(name: $name)
          }
        }
      `,
      variables() {
        return {
          name: this.name,
        }
      },
      update(data) {
        this.show = !data.me.hasDismissedAlert
      },
    },
  },

  methods: {
    async dismiss() {
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation DismissAlert($localId: Int!, $name: String!) {
              dismissAlert(input: { localId: $localId, name: $name }) {
                globalId
                hasDismissedAlert(name: $name)
              }
            }
          `,
          variables: {
            localId: this.userId,
            name: this.name,
          },
        })
        .then((data) => {
          this.show = !data?.data?.dismissAlert?.hasDismissedAlert
        })
    },
  },
}
</script>
